import React,{ useState, useEffect } from "react";
import "../components/weather.css";
import {ReactComponent as SunSVG} from '../assets/new-weather/sun.svg';
import {ReactComponent as CloudDrizzleRainSVG} from '../assets/new-weather/drizzle-rain.svg';
import {ReactComponent as SimpleRainSVG} from '../assets/new-weather/heavy-rain.svg';
import {ReactComponent as CloudySVG} from '../assets/new-weather/sun-cloud.svg';
import {ReactComponent as FogSVG} from '../assets/new-weather/fog.svg';
import {ReactComponent as SnowSVG} from '../assets/new-weather/snow.svg';
import {ReactComponent as StormSVG} from '../assets/new-weather/lightning-storm.svg'
import {ReactComponent as FrozenRainSVG} from '../assets/new-weather/frozen-rain.svg'



const WeatherSmall = ({ destinationWeather }) => {
    const [weatherData, setWeatherData] = useState(null);
    const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en'; // Get selected language

    useEffect(() => {
        // Set weather data from props
        setWeatherData(destinationWeather);
    }, [destinationWeather]);

    if (!weatherData) {
        return <div className="weather-container">Loading weather data...</div>;
    }

    const { dailyWeatherData } = weatherData;

    const weatherIcons = {
        0: <SunSVG />, // Clear sky
        1: <CloudySVG />, // Mainly clear
        2: <CloudySVG />, // Partly cloudy
        3: <CloudySVG />, // Overcast
        45: <FogSVG />, // Fog
        48: <FogSVG />, // Depositing rime fog
        51: <CloudDrizzleRainSVG />, // Light drizzle
        53: <CloudDrizzleRainSVG />, // Moderate drizzle
        55: <CloudDrizzleRainSVG />, // Dense drizzle
        56: <FrozenRainSVG />, // Freezing drizzle (Light)
        57: <FrozenRainSVG />, // Freezing drizzle (Dense)
        61: <SimpleRainSVG />, // Light rain
        63: <SimpleRainSVG />, // Moderate rain
        65: <SimpleRainSVG />, // Heavy rain
        66: <FrozenRainSVG />, // Light freezing rain
        67: <FrozenRainSVG />, // Heavy freezing rain
        71: <SnowSVG />, // Light snow
        73: <SnowSVG />, // Moderate snow
        75: <SnowSVG />, // Heavy snow
        77: <SnowSVG />, // Snow grains
        80: <CloudDrizzleRainSVG />, // Slight rain showers
        81: <CloudDrizzleRainSVG />, // Moderate rain showers
        82: <SimpleRainSVG />, // Violent rain showers
        85: <SimpleRainSVG />, // Slight snow showers
        86: <SimpleRainSVG />, // Heavy snow showers
        95: <StormSVG />, // Thunderstorm (Slight or moderate)
        96: <StormSVG />, // Thunderstorm with hail (Slight)
        99: <StormSVG />, // Thunderstorm with hail (Heavy)
    };

    const getWeatherIcon = (code) => weatherIcons[code] || <SunSVG />;

    // Limit to 6 days of weather data
    const limitedDailyData = Object.keys(dailyWeatherData).slice(0, 6);

    return (
        <div className="weather-container">
            <div className="weather-summary">
                {limitedDailyData.length > 0 ? (
                    limitedDailyData.map((date, index) => (
                        <div key={index} className="weather-day">
                            {getWeatherIcon(dailyWeatherData[date].weatherCode)}
                            <h3>
                                {new Date(date).toLocaleDateString(selectedLanguage, { weekday: "long" })}
                            </h3>
                            <p>
                                {dailyWeatherData[date].maxTemp}°C &nbsp; 
                                {dailyWeatherData[date].minTemp}°C
                            </p>
                        </div>
                    ))
                ) : (
                    <p>No weather data available</p>
                )}
            </div>
        </div>
    );
};

export default WeatherSmall;
